module.exports = __webpack_public_path__ + "img/twitter_logo.c2f1acf6.svg";